import {Routes} from '@angular/router';
import {MainComponent} from "./main/main.component";
import {MsalGuard} from "@azure/msal-angular";

export const routes: Routes = [
  {path: '', component: MainComponent, canActivate: [MsalGuard] },
  {path: '**', redirectTo: ''}
];
